import { Box } from '@mui/material';
import { Collections } from '@mui/icons-material';
import StreetViewImage from '../StreetViewImage/StreetViewImage';
import { listings, mlsListings } from '@prisma/client';

interface MLSListingImageProps {
  listing: listings & { mlsListing?: mlsListings | null };
  height?: string | number;
  width?: string | number;
  onClick?: () => void;
}

const MLSListingImage: React.FC<MLSListingImageProps> = ({
  listing,
  height = 120,
  width = '100%',
  onClick,
}) => {
  // Check for MLS photos first
  const mlsPhotos = listing.mlsListing?.photos;
  const hasMLSPhotos = mlsPhotos && mlsPhotos.length > 0;
  const hasMultiplePhotos = mlsPhotos && mlsPhotos.length > 1;

  if (hasMLSPhotos) {
    return (
      <Box
        sx={{
          width,
          height,
          borderRadius: 1,
          overflow: 'hidden',
          backgroundColor: 'grey.100',
          position: 'relative',
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={onClick}
      >
        <img
          src={mlsPhotos[0]}
          alt={`${listing.address}, ${listing.city}, ${listing.state}`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          onError={(e) => {
            // If image fails to load, hide it and show fallback
            e.currentTarget.style.display = 'none';
          }}
        />

        {/* Photo indicator overlay */}
        {hasMultiplePhotos && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              color: 'white',
              padding: '4px 8px',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              fontSize: '12px',
              opacity: 0.8,
            }}
          >
            <Collections sx={{ fontSize: 16 }} />
            <span>{mlsPhotos.length}</span>
          </Box>
        )}
      </Box>
    );
  }

  // Fallback to Street View
  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: 1,
        overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      <StreetViewImage
        address={`${listing.address} ${listing.city}, ${listing.state} ${listing.zip}`}
        height={typeof height === 'number' ? `${height}px` : height}
      />
    </Box>
  );
};

export default MLSListingImage;
